import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { Dialog, FlatButton } from "material-ui"
import AccountUserOrganizationHierarchyAndUserRole from "./AccountUserOrganizationHierarchyAndUserRole"
interface IProps {
    organizationHierarchyId: string
    userRoleId: string
    handleSave(organizationHierarchyId: string, userRoleId: string): void
    handleClose(): void
}
interface IState {

}

export default class AccountUserSettingsDialog extends React.Component<IProps, IState>  {
    private AccountUserOrganizationHierarchyAndUserRole
    constructor(props) {
        super(props)
        autobind(this)
    }

    handleSave() {
        if (this.AccountUserOrganizationHierarchyAndUserRole.state.errorOrganizationHierarchyId || this.AccountUserOrganizationHierarchyAndUserRole.state.errorUserRoleId)
            return
        this.props.handleSave(this.AccountUserOrganizationHierarchyAndUserRole.state.organizationHierarchyId, this.AccountUserOrganizationHierarchyAndUserRole.state.userRoleId)
    }

    render() {
        return (
            <Dialog
                modal
                open
                title={strings.Account_User_Settings}
                actions={[
                    <FlatButton
                        label={strings.Cancel}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        label={strings.Save}
                        primary
                        onClick={this.handleSave}
                    />
                ]}
                onRequestClose={this.props.handleClose}
            >
                <AccountUserOrganizationHierarchyAndUserRole
                    ref={item => this.AccountUserOrganizationHierarchyAndUserRole = item}
                    organizationHierarchyId={this.props.organizationHierarchyId}
                    userRoleId={this.props.userRoleId}
                />
            </Dialog>
        )
    }
}